import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import type { GenerateUniqueOrganizationSlugPayload } from "@casey/db-types";
import { GENERATE_UNIQUE_SLUG } from "../gql";

interface GenerateUniqueSlugVariables {
  name: string;
}

interface GenerateUniqueSlugResponse {
  generateUniqueOrganizationSlug: GenerateUniqueOrganizationSlugPayload;
}

export function useGenerateUniqueSlug() {
  const [generateUniqueSlugMutation, { data, loading, error }] = useMutation<
    GenerateUniqueSlugResponse,
    GenerateUniqueSlugVariables
  >(GENERATE_UNIQUE_SLUG, {
    errorPolicy: "all",
  });

  const generateSlug = useCallback(
    async (name: string): Promise<string | null> => {
      if (!name || name.trim().length === 0) {
        return null;
      }

      try {
        const result = await generateUniqueSlugMutation({
          variables: { name: name.trim() },
        });

        return result.data?.generateUniqueOrganizationSlug?.string ?? null;
      } catch (err) {
        console.error("Error generating unique slug:", err);
        return null;
      }
    },
    [generateUniqueSlugMutation],
  );

  return {
    generateSlug,
    generatedSlug: data?.generateUniqueOrganizationSlug?.string,
    loading,
    error,
  };
}
